module.exports = __webpack_public_path__ + "img/premium_slideimage05.9a31d8f3.jpg";